function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "social_facebook_circle",
  "data-name": "social facebook circle",
  d: "M25.1,4.308A14.167,14.167,0,0,0,14.7,0a14.167,14.167,0,0,0-10.4,4.308A14.167,14.167,0,0,0,0,14.7,14.167,14.167,0,0,0,4.308,25.1a14.167,14.167,0,0,0,10.4,4.308A14.167,14.167,0,0,0,25.1,25.1a14.167,14.167,0,0,0,4.308-10.4A14.167,14.167,0,0,0,25.1,4.308ZM18.5,14.7H16.083V23.55H12.809V14.7h-2.24V11.66h2.24V9.88a5.036,5.036,0,0,1,.747-3.016A3.319,3.319,0,0,1,16.37,5.859h2.412V8.9H17.289q-.8,0-1.005.287a1.769,1.769,0,0,0-.2.976V11.66H18.84ZM29.409,27.571",
  fill: "#cc9c4e"
});

function SvgSocialFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.409,
    height: 29.409,
    viewBox: "0 0 29.409 29.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.0df5ac2d.svg";
export { ForwardRef as ReactComponent };